export default __webpack_public_path__ + "static/foca-d5bbb744b21b94cabadf5547b7bc2d57.png";